import React from "react"
import { graphql } from "gatsby"

import Tag from "components/tag"

const TagPage = (props) => {
  const {
    data: {
      tag,
      allArticle: { nodes: articles },
    },
  } = props

  return <Tag tag={tag} articles={articles} />
}

export default TagPage

export const query = graphql`
  query ($slug: String) {
    tag(slug: { eq: $slug }) {
      id
      tag
      slug
    }

    allArticle(filter: { tagSlugs: { in: [$slug] } }, sort: { publishDate: DESC }, limit: 500) {
      nodes {
        ... on Article {
          ...articleCardFields
        }
      }
    }
  }
`

export async function config() {
  return () => ({
    defer: false,
  })
}
